import { z } from 'zod';

export const CustomVizProgressStep = z.enum([
  'generalRunningAnalysisFallback',
  'generalAnalysisStarting',
  'biasAnalysisApplyingFilters',
  'biasAnalysisPreparingIterations',
  'biasAnalysisCalculatingDisparitiesAndBiases',
  'biasAnalysisPreparingOutputs',
  'heatmapApplyingFilters',
  'heatmapPreparingIterations',
  'heatmapCalculatingIterations',
  'heatmapPreparingOutputs',
  'progressPreparingIterations',
  'progressApplyingFilters',
  'progressCalculatingIterations',
  'progressPreparingOutputs',
  'pipelineAnalysisRunningAnalysis',
  'binScatterApplyingFilters',
  'binScatterCalculating',
  'successPhenotypeApplyingFilters',
  'successPhenotypeModelTraining',
  'successPhenotypeCalculating',
  'successPhenotypePreparingOutputs',
  'timeSeriesTrendsCalculating',
  'timeSeriesTrendsApplyingFilters',
]);

export type CustomVizProgressStep = z.infer<typeof CustomVizProgressStep>;
